import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'
import { useMediaQuery } from 'src/lib/use-media-query'

export const TextHeaderRo = () => {
    const isMobile = useMediaQuery('(max-width: 539px)')

    return (
        <HighlightedText
            text="ÎNTORCEȚI ROATA ȘI PRIMIȚI ROTIRI GRATUITE"
            highlights={[{ word: 'ROTIRI GRATUITE' }]}
            breakAfterWords={isMobile ? ['ROATA', 'PRIMIȚI'] : ['PRIMIȚI']}
            className={styles.text_header}
        />
    )
}
